
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">IT Facility Closer</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
         <select class="form-select" [(ngModel)]="ITcloserData.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeId" [value]="emp.MD_EmployeeId">{{ emp.MD_EmployeeId }}</option>
          </select> 
        
          <!--<input class="form-control" [(ngModel)]="ITcloserData.OD_EmployeeID" name="OD_EmployeeID" />-->
        
        </div>
        
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Full Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Fullname" name="lastName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">AD User Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_ADUserName" name="MD_ADUserName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mail ID</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_ADMailId" name="MD_ADMailId" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Designation</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Designation" name="MD_Designation" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">location</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Grade" name="MD_Grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Department" name="MD_Department" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Microsoft Dynamic 360 Access</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Micsoftdynamic360" name="MD_Micsoftdynamic360" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Company Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_company_name" name="MD_company_name" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">User Id</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_UserId" name="MD_UserId" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Reporter Name</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_ReporterName" name="MD_ReporterName" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Role Center</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_RoleCenter" name="MD_RoleCenter" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Previlage Access</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Previlage_Access" name="MD_Previlage_Access" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Approve Access</label>
          <input class="form-control" [(ngModel)]="ITcloserData.MD_Approval_Access" name="MD_Approval_Access" /><!--*ngIf="appservice.editchecker==='rejected'"-->
        </div>
        <div class="mb-3 d-flex align-items-center" >
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="ITcloserData.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div>

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button class="btn btn-approve" type="button" (click)="onApprove()">Approve</button><!-- " (click)="onApprove()(click)="onDecline()*ngIf="appservice.checkereditdata.status === 'Approved' *ngIf="appservice.checkereditdata.status === 'Rejected'-->
          <button class="btn btn-decline" type="button" (click)="onDecline()">Decline</button>
        </div>
      </form>
    </div>
  </div>
</div>
